/**
 * 等新页面真正挂上后再滚顶。
 * afterEach 时旧列表往往还在 #app 里，一滚就会闪出学习中心目录。
 */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('page:finish', () => {
    nextTick(() => {
      requestAnimationFrame(() => {
        const app = document.querySelector('#app')
        if (app) app.scrollTop = 0
      })
    })
  })
})
